module.exports = "<div class=\"stat-legend\"></div><div class=\"stat-sequence\"></div><div class=\"stat-chart\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/stat/pie.component.html
// module id = 929
// module chunks = 0